module.exports = __webpack_public_path__ + "img/trent.9be8155c.jpg";